import React from "react";
import { ConnectingBlock } from "../Connecting/styled";
import { Container, Heading, Text } from "../../styled";
import { useHistory } from "react-router";
import Button from "../design_components/Button/Button";
import { createEventObjectFunction } from "../../utils/helper";
import { onboardingFillEventAmplitude } from "../../amplitude/events";
import { onboardingFillEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";

const ConnectingSecond = ({ data, type, currentRoute, answers, landingId }) => {
  const history = useHistory();

  const handleButtonClick = () => {
    const eventObj = createEventObjectFunction(
      data.eventFillName,
      null,
      landingId
    );
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    history.push(data.nextRoute);
  };

  const renderImgBlock = () => {
    if (type === 5) {
      return <img src={setImg()} alt="graph" />;
    }
    if (type === 6) {
      return (
        <ConnectingBlock.Comment
          style={{
            minHeight: 410,
            maxWidth: 330,
            overflow: "hidden",
            margin: "0 auto",
            borderRadius: 12,
          }}
        >
          <img
            style={{ width: "100%", maxWidth: "none" }}
            src={setImg()}
            alt="graph"
          />
          <ConnectingBlock.Comment.Item>
            <Text.Six style={{ marginBottom: 9 }}>{data.comment}</Text.Six>
            <Text.Six>
              {data.dependOn
                ? data.name[answers[data.dependOn[0]][0]]
                : data.name}
            </Text.Six>
          </ConnectingBlock.Comment.Item>
        </ConnectingBlock.Comment>
      );
    }
  };

  const renderBottomBlock = () => {
    if (type === 5) {
      return (
        <ConnectingBlock.Top.Double>
          <ConnectingBlock.Top.Double.Img>
            <img src={data.imgSmall} alt="img" />
          </ConnectingBlock.Top.Double.Img>
          <ConnectingBlock.Top.Double.Text>
            {data.text.map((text) => {
              return (
                <ConnectingBlock.Top.Double.Item>
                  <Text.Fifth>
                    <p dangerouslySetInnerHTML={text} />
                  </Text.Fifth>
                </ConnectingBlock.Top.Double.Item>
              );
            })}
          </ConnectingBlock.Top.Double.Text>
        </ConnectingBlock.Top.Double>
      );
    }
    if (type === 6) {
      return (
        <ConnectingBlock.Bottom.Text>
          <Text.Fourth>{data.text}</Text.Fourth>
        </ConnectingBlock.Bottom.Text>
      );
    }
  };

  const setImg = () => {
    if (data.dependOn) {
      return data.imgBig[answers[data.dependOn[0]][0]];
    } else {
      return data.imgBig;
    }
  };

  return (
    <ConnectingBlock>
      <Container.Content>
        <ConnectingBlock.Wrapper>
          <ConnectingBlock.Top>
            <ConnectingBlock.Top.Title>
              <Heading.Third>{data.title}</Heading.Third>
            </ConnectingBlock.Top.Title>
            <ConnectingBlock.Top.Img
              style={
                type === 5
                  ? { marginBottom: 30, minHeight: 300 }
                  : { marginBottom: 20 }
              }
            >
              {renderImgBlock()}
            </ConnectingBlock.Top.Img>
            {renderBottomBlock()}
          </ConnectingBlock.Top>
          <ConnectingBlock.Bottom>
            <Button
              type={"default"}
              text={data.buttonText ? data.buttonText : "Next"}
              isGradient={true}
              action={handleButtonClick}
            />
          </ConnectingBlock.Bottom>
        </ConnectingBlock.Wrapper>
      </Container.Content>
    </ConnectingBlock>
  );
};

export default ConnectingSecond;
